module.exports = __webpack_public_path__ + "static/media/view2.f4917ad2.jpg";